var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-input',{class:_vm.fieldClasses,attrs:{"type":"number","value":_vm.currentValue,"readonly":_vm.isReadOnly,"placeholder":_vm.fieldPlaceholder},on:{"input":function($event){return _vm.updateField(_vm.field, $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }